import React from 'react';

import { Attributes } from './types';
import { Box, Stack, Tooltip, Typography } from '@mui/material';

interface Props {
  attributes: Attributes;
}

const EmrTooltip = ({ emrPatientId, emrInstance }: { emrPatientId: string; emrInstance: string }) => (
  <Stack spacing={0.5} sx={{ p: 0.5 }}>
    <Box>
      <Typography variant="caption" color="inherit" display="block">
        EMR ID
      </Typography>
      <Typography variant="body2" color="inherit" fontWeight="medium">
        {emrPatientId}
      </Typography>
    </Box>
    <Box>
      <Typography variant="caption" color="inherit" display="block">
        EMR Instance
      </Typography>
      <Typography variant="body2" color="inherit" fontWeight="medium">
        {emrInstance}
      </Typography>
    </Box>
  </Stack>
);

const PatientId = ({ attributes }: Props): JSX.Element => (
  <div>
    <Typography data-testid="patient-name-block" variant="h6" fontWeight="bold">
      {attributes.fullName}
    </Typography>
    <Tooltip
      enterDelay={500}
      arrow
      title={
        attributes.emrPatientId && attributes.emrInstance ? (
          <EmrTooltip emrPatientId={attributes.emrPatientId} emrInstance={attributes.emrInstance} />
        ) : (
          ''
        )
      }>
      <Typography variant="body2" id="patient-id-block" sx={{ cursor: 'default', width: 'fit-content' }}>
        Patient ID:{' '}
        <Typography component="span" variant="inherit" fontWeight="bold">
          {attributes.ida}
        </Typography>
      </Typography>
    </Tooltip>
  </div>
);

export default PatientId;
